const VERSION_URL = '/version.json';
const POLL_INTERVAL_MS = 5 * 60 * 1000;

export function getEmbeddedBuildId() {
    return process.env.REACT_APP_BUILD_ID || '';
}

export function isVersionCheckEnabled() {
    if (process.env.NODE_ENV === 'development') {
        return false;
    }
    const host = window.location.hostname;
    return host !== 'localhost' && host !== '127.0.0.1';
}

export async function fetchLatestBuildId() {
    const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
        cache: 'no-store',
        headers: {
            'Cache-Control': 'no-cache'
        }
    });

    if (!response.ok) {
        return null;
    }

    const payload = await response.json();
    return payload?.buildId || null;
}

export async function isNewVersionAvailable() {
    const embeddedBuildId = getEmbeddedBuildId();
    if (!embeddedBuildId) {
        return false;
    }

    const latestBuildId = await fetchLatestBuildId();
    if (!latestBuildId) {
        return false;
    }

    return latestBuildId !== embeddedBuildId;
}

export function getVersionPollIntervalMs() {
    return POLL_INTERVAL_MS;
}
